namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmProfilVlastnosti extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmProfilVlastnostiReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmProfilVlastnostiObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmProfilVlastnostiObj());
            this.detailObj.createBase({
                contentName: "detailAdmProfilVlastnosti",
                contentCaption: "jres:29802650",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.createAdmProfilVlastnostiObsahSubTask())
                tabs.push(this.detailObj.createAdmProfilVlastnostiVazbySubTask())
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.createAdmProfilVlastnostiObsahGroup())
                groups.push(this.detailObj.createAdmProfilVlastnostiVazbyGroup())
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmProfilVlastnosti", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmProfilVlastnostiObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmProfilVlastnostiReadDto> {
        private gridVazby: JQuery<HTMLElement>;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_pro) ? this.data.ixs_pro.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmProfilVlastnostiSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmProfilVlastnosti.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinspro");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmProfilVlastnosti", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmProfilVlastnosti.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                        { action: this.cnt.actions.actOpenSeznamAdmProfilObjekt },
                        { action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmProfilObjekt: {
                    icon: "fa-link",
                    caption: "jres:33000415",
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmProfilObjekt()
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000510", //RC 33000510 : Umo�n� p�i�adit vlastnost jako p�eddefinovan� k vybran�m typ�m dokument�
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenDetailVlastnostStruktura: {
                    caption: "jres:32131033", //RC 33000561 : Detail strutury nebo vlastnosti
                    tooltip: "jres:33000562", //RC 33000562 : Otev�e detail struktury nebo vlastnosti 
                    icon: "gi-detail",
                    run: (ev, ctx) => {
                        this.openDetailVlastnostProfil();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_pro");
            this.MakeField("nazev" );
            this.MakeField("zkratka" );
            this.MakeField("kod", {
                flag: this.createFlagNemenne(),
                validators: [
                    new Gordic.Validators.Required({ stopping: true }),
                    new Gordic.Validators.Length({ min: 0, max: 6 }),
                    this.createValidatorKod()
                ]
            });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private createValidatorKod(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000480".format("_"), //RC 33000480 : Zadan� �et�zec obsahuje nepovolen� znaky.
                validate: (value, source) => {
                    if (value) {
                        if (value.toString().includes("_"))
                            return false;
                        if (value.toString() == "0")
                            return false;
                        return true;
                    }
                    return false;
                }
            });
        }

        createAdmProfilVlastnostiObsahSubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-adm-profil-vlastnosti-obsah",
                    title: "jres:33000507", //RC 33000507 : Struktury a vlastnosti profilu
                    opened: true,
                    locked: true,
                    group: { id: "_tab-adm-profil-vlastnosti-obsah" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmProfilVlastnostiObsah",
                    serverParams: {
                        Id: "SeznamAdmProfilVlastnostiObsah",
                        ixs_pro: this.data.ixs_pro,
                        tabOpen: true
                    }
                }
            }
        }

        createAdmProfilVlastnostiVazbySubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-adm-profil-vazby",
                    title: "jres:33000558", //RC 33000558 : Vazby profilu
                    opened: true,
                    locked: true,
                    group: { id: "_tab-adm-profil-vazby" },
                    menuBar: this.cnt.actions.createBar(["actOpenDetailVlastnostStruktura*"]),
                    open: () => {
                        this.getVazbyProfilu();
                    }
                },
                init: (tab) => {
                    this.createGridVazby(tab);
                }
            }
        }

        createAdmProfilVlastnostiObsahGroup(): IGTabGroupOptions {
            return { id: "_tab-adm-profil-vlastnosti-obsah", caption: "jres:33000507" }
        }

        createAdmProfilVlastnostiVazbyGroup(): IGTabGroupOptions {
            return { id: "_tab-adm-profil-vazby", caption: "jres:33000558" }
        }

        private openSeznamAdmProfilObjekt() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                Id: "SeznamAdmVlastnostTypObjektu",
                typ_vps: 0,
                ixs: this.data.ixs_pro
            })
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                Id: "SeznamAdmVlastnostTypDokumentu",
                typ_vps: 0,
                ixs: this.data.ixs_pro
            })
        }

        private createGridVazby(tab: JQuery<HTMLElement>) {
            this.gridVazby =  $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.createGridFormatVazby(),
                defaultAction: this.cnt.actions.actOpenDetailVlastnostStruktura,
                selection: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailVlastnostStruktura?.update({ enabled: ctx.count == 1 })
                }
            })
        }

        private createGridFormatVazby(): Gordic.Data.GridFormat {
            return new Gordic.Data.GridFormat()
                .addStructureColumn({
                    name: "ixs_txt",
                    caption: "jres:32131029",
                })
                .addIconColumn({
                    name: "aktivita",
                    caption: "jres:33000559", //RC 33000559 : Aktivita vazby
                    iconTemplate: (row) => {
                        return Gordic.Adm.WebControls.GAdmGridFunctions.createAktivitaCaptionIcon(row.aktivita);
                    }
                })
                .addTextColumn({
                    name: "typ",
                    caption: "jres:33000553",
                    cellTemplate: (row) => {
                        if (row.typ == 20)
                            return "jres:29932128";
                        else if (row.typ == 10)
                            return "jres:29931622";
                        else
                            return "jres:33000410"
                    }
                })
                .addNumberColumn({
                    name: "poradi",
                    caption: "jres:30029253"
                })
        }

        private getVazbyProfilu() {
            if (this.gridVazby != undefined && this.gridVazby != null) {
                if (this.data.ixs_pro) {
                    this.cnt.isl.AdmProfilVlastnosti.listVazby({ ixs_pro: this.data.ixs_pro }).getData().done((obj) => {
                        let treeProcessor = new Gordic.Data.Tree(Gordic.Data.Tree.parentIdOrganizer("ixs_nad"), { defaultState: "open" })
                        var view = new Gordic.Data.View(obj, {
                            key: "ixs",
                            processors: { tree: treeProcessor }
                        })
                        this.gridVazby.ggrid("setData", view);
                    })
                }
            }
        }

        private openDetailVlastnostProfil() {
            var activeRow = this.gridVazby.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.typ == 20) {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmVlastnost", {}],
                        {
                            ID: "DetailAdmVlastnost",
                            newRecord: false,
                            ixs_vla: activeRow.ixs
                        }
                    )
                } else if (activeRow.typ == 10) {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", {}],
                        {
                            ID: "DetailAdmStrukturaVlastnosti",
                            newRecord: false,
                            ixs_stv: activeRow.ixs
                        }
                    )
                } else {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmProfilVlastnosti", {}],
                        {
                            ID: "DetailAdmProfilVlastnosti",
                            newRecord: false,
                            ixs_pro: activeRow.ixs
                        }
                    )
                }
            }
        }
    }
}